import { createFileRoute } from '@tanstack/react-router'

import { ShootLogistics, WizardStep } from '@/components/onboarding'
import { ADDRESS, ANSWERS, PEOPLE, SHOOT_WINDOWS } from '@/mocks/onboarding/foceni'

/** Before and after they answer. */
type FoceniSearch = { stav?: 'vyplneno' }

export const Route = createFileRoute('/onboarding/foceni')({
  validateSearch: (search: Record<string, unknown>): FoceniSearch =>
    search.stav === 'vyplneno' ? { stav: 'vyplneno' } : {},
  head: () => ({ meta: [{ title: 'Focení u vás · Aplikace Bitez' }] }),
  component: OnboardingFoceni,
})

/**
 * Step 3 — how a shoot happens at their place. Not about how they look, but
 * about the quarter of an hour that gets wasted when a photographer stands in
 * front of a locked side door with a bag of lights.
 *
 * Every answer here is from memory: when service allows it, what to avoid,
 * where to park, who will be there. That is why it survived the cut to three
 * steps while the logo and the menus did not.
 */
function OnboardingFoceni() {
  const { stav } = Route.useSearch()
  const filled = stav === 'vyplneno'

  return (
    <WizardStep
      step={3}
      backHref="/onboarding/hlas"
      nextHref="/onboarding/hotovo"
      note="Tohle uvidí fotograf v briefu, než k vám vyrazí. Ušetří to čtvrthodinu oběma."
      skip={filled ? undefined : { label: 'Domluvíme se později', href: '/onboarding/hotovo' }}
    >
      <ShootLogistics
        address={ADDRESS}
        windows={SHOOT_WINDOWS}
        people={PEOPLE}
        answers={filled ? ANSWERS : undefined}
      />
    </WizardStep>
  )
}
